import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { UserCheck, UserX } from 'lucide-react';
export function WhoIsForSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-156">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="bg-brand-cream/50 p-8 rounded-xl h-full" data-id="element-159">
            <div className="flex items-center gap-3 mb-6" data-id="element-160">
              <UserCheck className="w-8 h-8 text-green-700" data-id="element-161" />
              <h3 className="text-2xl font-bold" data-id="element-162">Para quién es</h3>
            </div>
            <ul className="space-y-4 text-lg" data-id="element-163">
              <li className="flex gap-2" data-id="element-164">
                <span data-id="element-165">•</span> Padres separados o divorciados con custodia
                compartida o fines de semana alternos.
              </li>
              <li className="flex gap-2" data-id="element-166">
                <span data-id="element-167">•</span> Hombres que sienten que sus hijos se están
                distanciando emocionalmente.
              </li>
              <li className="flex gap-2" data-id="element-168">
                <span data-id="element-169">•</span> Papás que odian el silencio tenso en el coche
                tras recoger a los niños.
              </li>
              <li className="flex gap-2" data-id="element-170">
                <span data-id="element-171">•</span> Padres que quieren dejar de ser "animadores" y
                volver a ser "referentes".
              </li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-172">
          <div className="bg-gray-50 p-8 rounded-xl h-full border border-gray-200" data-id="element-173">
            <div className="flex items-center gap-3 mb-6" data-id="element-174">
              <UserX className="w-8 h-8 text-red-700" data-id="element-175" />
              <h3 className="text-2xl font-bold" data-id="element-176">Para quién NO es</h3>
            </div>
            <ul className="space-y-4 text-lg text-gray-600" data-id="element-177">
              <li className="flex gap-2" data-id="element-178">
                <span data-id="element-179">•</span> Padres que buscan consejos legales o estrategias
                de pleitos judiciales.
              </li>
              <li className="flex gap-2" data-id="element-180">
                <span data-id="element-181">•</span> Personas que no están dispuestas a cambiar su
                forma de comunicarse.
              </li>
              <li className="flex gap-2" data-id="element-182">
                <span data-id="element-183">•</span> Padres que creen que el dinero puede sustituir a
                la presencia consciente.
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}